<template>
    <div class="mdiv_biglayout">
        <div class="page" v-if="objExperience != null && objExperience.experienceInfo != null">
            <div class="head">
                <img :src="headImg" alt="" />
            </div>

            <!-- 标题 -->
            <div class="experience_title">
                <span>{{objExperience.experienceInfo.title}}</span>
            </div>

            <!-- 内容 -->
            <div class="ck-editor-content content_margin">
                <span class="span_experience_content" v-html="objExperience.experienceInfo.displayContent" style="word-break: break-all;"/></div>

            <!-- 底部入口 -->
            <div class="bottom_action" :style="{'height': adapterScreenHeight()}">
                <div id="lookCourseBlogOpenApp" class="listen" v-if="courseType === 3">App内试听</div>
                <div class="listen" v-if="courseType === 1 || courseType === 2" @click="showAction()">试听</div>
                <div class="buy" @click="buyClick()">立即购买</div>
            </div>

            <mt-actionsheet
                    :actions="actions"
                    v-model="flag">
            </mt-actionsheet>
        </div>

    </div>
</template>

<script>

    export default {
        name: "courseblog",
        data() {
            return {
                courseType: 0,
                objExperience: {},
                flag: false,
                actions: [],
                headImg: ""
            }
        },
        methods: {
            getHeadImage: function(guid) {
                if (guid === "65f98a95cb975bef") {
                    return require("@/Images/head_success.jpg");
                } else if (guid === "5aac20819410da48") {
                    return require("@/Images/head_240word.jpg");
                } else if (guid === "5d8d219d5fd178c0") {
                    return require("@/Images/head_big_cat.jpg");
                }
            },
            buyClick() {
                let strUrl = "";

                if (this.courseType === 1) {
                    strUrl = "https://shop19607582.m.youzan.com/wscgoods/detail/1y410y3atdpjq";
                } else if (this.courseType === 2) {
                    strUrl = "https://h5.youzan.com/v2/showcase/goods?alias=2op4ui0v5yprq&from=wsc&kdtfrom=wsc";
                } else if (this.courseType === 3) {
                    strUrl = "https://shop19607582.m.youzan.com/wscgoods/detail/2xk60e1h8nexi";
                }

                if (!this.isEmpty(strUrl)) {
                    window.open(strUrl,'_blank');
                }
            },
            adapterScreenHeight: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "50px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "86px" : "50px";
            },
            showAction() {
                if (this.courseType === 1) {
                    this.actions = [{name: "G1", method: this.g1Click},
                        {name: "G2", method: this.g2Click},
                        {name: "G3", method: this.g3Click}];
                } else if (this.courseType === 2) {
                    this.actions = [{name: "G1", method: this.g1Click},
                        {name: "G2", method: this.g2Click},
                        {name: "G3", method: this.g3Click}];
                }

                this.flag = true;
            },
            g1Click() {
                if (this.courseType === 1) {
                    window.open(this.getCurrentDomainUrl() + "sbefore?courseId=1",'_blank');
                } else if (this.courseType === 2) {
                    window.open(this.getCurrentDomainUrl() + "before?courseId=1",'_blank');
                }
            },
            g2Click() {
                if (this.courseType === 1) {
                    window.open(this.getCurrentDomainUrl() + "sbefore?courseId=2",'_blank');
                } else if (this.courseType === 2) {
                    window.open(this.getCurrentDomainUrl() + "before?courseId=2",'_blank');
                }
            },
            g3Click() {
                if (this.courseType === 1) {
                    window.open(this.getCurrentDomainUrl() + "sbefore?courseId=3",'_blank');
                } else if (this.courseType === 2) {
                    window.open(this.getCurrentDomainUrl() + "before?courseId=3",'_blank');
                }
            },
            readyPage:function () {
                var divWidth = parseInt($(".page").css("width").replace("px", ""));

                $('.ck-editor-content .lazy').each(function () {
                    var imgWidth = parseInt($(this).attr("data-w")); // 图片最大宽度
                    var imgRatio = parseFloat($(this).attr("data-ratio"));  // 缩放比例
                    var imgHeight = 0;  // 图片实际高度

                    if (divWidth > imgWidth) {
                        if (imgWidth > divWidth - 30) {
                            imgWidth = divWidth - 30;
                        }
                        imgHeight = parseInt(imgWidth * imgRatio);
                    } else {
                        imgWidth = divWidth - 30;
                        imgHeight = parseInt(imgWidth * imgRatio);
                    }

                    window.console.log(imgWidth);
                    window.console.log(imgHeight);

                    $(this).attr("style", "height:" + imgHeight + "px;" + "width:" + imgWidth + "px;")
                });

                $(".ck-editor-content .lazy").lazyload({
                    placeholder: "/lazyload/grey.gif"
                });

                $(".ck-editor-content img").each(function (idex, item) {
                    var vSrc = $(item).attr("src");

                    if (vSrc.indexOf("/lazyload/grey.gif") !== -1) {
                        vSrc = $(item).attr("data-original");
                    }
                });
            },
        },
        beforeCreate () {
            let that = this;
            let vCourseType = parseInt(this.$route.query.type);
            let vGUID = this.$route.query.id;

            let url = "mobileSite/viewExperience/" + vGUID;

            this.$axios.get(url).then((response) => {
                that.courseType = vCourseType;
                that.headImg = that.getHeadImage(vGUID);
                that.objExperience = response.data;

                this.$nextTick(() => {
                    setTimeout(() => {
                        this.readyPage();
                    }, 1000)
                });
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {

        }
    }
</script>

<style scoped>

    .mdiv_biglayout {
        width: 100%;
        text-align: center;
    }
    .page .head {
        width: 100%;
    }

    .page .head img {
        width: 100%;
    }

    .experience_title
    {
        font-size: 25px;
        color: #333333;
        font-weight: bold;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 5px;
        margin-top: 15px;
        text-align: left;
    }

    .content_margin
    {
        margin-left: 15px;
        margin-right: 15px;
        padding-bottom: 85px;
    }

    .span_experience_content {
        text-align: left;
    }

    .bottom_action {
        position:fixed;
        bottom: 0px;
        background-color: white;
        width: 100%;
        max-width: 650px;
    }
    .bottom_action .listen
    {
        float: left;
        width: 34%;
        height: 50px;
        background-color: #555555;
        color: white;
        font-size: 15px;
        text-align: center;
        line-height: 50px;
    }
    .bottom_action .buy
    {
        float: left;
        width: 66%;
        height: 50px;
        background-color: #ff5050;
        color: white;
        font-size: 15px;
        text-align: center;
        line-height: 50px;
    }

    /*新编辑器样式*/
    .ck-editor-content
    {
        color: #333;
        margin-bottom: 20px;
        font: 17px/1.8 "Microsoft YaHei" ,Arial,Helvetica,sans-serif, "宋体";
        letter-spacing:1px;
    }

    .ck-editor-content p
    {
        margin-top:0px;
        margin-bottom:0px;
        word-wrap: break-word;
    }

    .ck-editor-content blockquote {
        overflow: hidden;
        padding-right: 1.5em;
        padding-left: 1.5em;
        margin-left: 0;
        border-left: 5px solid #ccc;
        margin-top:0px;
        margin-bottom:0px;
    }

    .ck-editor-content figcaption
    {
        color: #999;
        font-size: .75em;
        outline-offset: -1px;
        padding-top: .6em;
        text-align:center;

    }

    .ck-editor-content figure
    {
        padding:0px;
        margin-left:0px;
        margin-right:0px;
        margin-top:10px;
        margin-bottom:10px;
        text-align: center;
    }

    .ck-editor-content figure img
    {
        border:0px;
        max-width: 100%;
    }

    .ck-editor-content >>> .image {
        padding: 0;
        margin: 0;
    }

</style>